export default "__VITE_ASSET__ByDUhj4A__"